import { render, staticRenderFns } from "./assessmentRecord.vue?vue&type=template&id=43a2dcca&scoped=true"
import script from "./assessmentRecord.vue?vue&type=script&lang=js"
export * from "./assessmentRecord.vue?vue&type=script&lang=js"
import style0 from "./assessmentRecord.vue?vue&type=style&index=0&id=43a2dcca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a2dcca",
  null
  
)

export default component.exports